import { Flow } from 'signup-constants/Flow';
import { Intent } from 'signup-constants/Intent';
import { Step } from 'signup-constants/Step';
import { Data } from 'signup-constants/signupData/Data';
import { VerificationType } from '../../app/VerificationType';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { getQueryParam } from '../../routing/getQueryParam';
import { getHistory } from '../../routing/history';
import { setVerificationType } from '../../store/app/action-creators';
import { getAuthenticatedUser } from '../../store/auth/selectors';
import { bulkUpdate } from '../../store/signup-data/action-creators';
import { Tracker } from '../../store/tracking/action-creators';
import { isFlow } from '../../utils/isFlow';
import { isIntent } from '../../utils/isIntent';
const IS_AEO_CREATE_BRAND_PURCHASE_FLOW = 'isAeoCreateBrandPurchaseFlow';
const stripFlagFromUrl = () => {
  const history = getHistory();
  const search = new URLSearchParams(history.location.search);
  search.delete(IS_AEO_CREATE_BRAND_PURCHASE_FLOW);
  const nextSearch = search.toString();
  history.replace(Object.assign({}, history.location, {
    search: nextSearch ? `?${nextSearch}` : ''
  }));
};
export const BranchAeoCreateBrandPurchase = {
  name: 'BranchAeoCreateBrandPurchase',
  stateCheck: state => {
    return isFlow(Flow.AeoStandalone) && isIntent(Intent.purchase) && getQueryParam(IS_AEO_CREATE_BRAND_PURCHASE_FLOW) === 'true' && !!getAuthenticatedUser(state);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const user = getAuthenticatedUser(state);
    if (!user) {
      return flow;
    }
    stripFlagFromUrl();
    dispatch(Tracker.signupInteraction('auto-create-brand-for-existing-user'));
    dispatch(setVerificationType(VerificationType.ExistingUser));
    dispatch(bulkUpdate({
      [Data.Email]: user.email,
      [Data.FirstName]: user.firstName,
      [Data.LastName]: user.lastName
    }));
    const stepsToRemove = [Step.ExistingUser, Step.LandingPage, Step.CodeVerification, Step.Password, ...(user.firstName && user.lastName ? [Step.Name] : [])];
    return dispatch(FlowStateManager.removeSteps(stepsToRemove, false));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};